// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__3HPO7"};